import React from 'react';

const LoaderWithoutStyles = () => <i className='fa fa-spinner fa-2x fa-spin' />;
export const LoadingInput = () => <div className='form-control'><i className='fa fa-spinner fa-spin' /></div>;

const Loading = ({ fullscreen, withoutStyles }) => {
  if (withoutStyles) {
    return <LoaderWithoutStyles />;
  }

  return (
    <div className={`text-center m-5 p-5 ${fullscreen && 'full-loader'}`} alt='Loading' data-testid='Loading'>
      <LoaderWithoutStyles />
    </div>
  );
};

export default Loading;
